<template>
  <footer class="sign-up-footer">
    <BravadoText tag="p" variant="subhead" class="sign-up-footer__log-in">
      Already a member?
      <button data-test="open-log-in-block" class="sign-up-footer__cta" @click="$listeners.navigateToSignIn">
        Log In
      </button>
    </BravadoText>

    <BravadoText tag="p" variant="caption2" class="sign-up-footer__terms">
      By signing up you agree with our
      <br />
      <a href="https://info.bravado.co/bravado-network-terms-of-service-for-users" target="_blank">
        terms and conditions
      </a>
    </BravadoText>
  </footer>
</template>

<script lang="ts">
import Vue from 'vue';
import BravadoText from '~/components/common/BravadoText/BravadoText.vue';

export default Vue.extend({
  name: 'SignUpFooter',
  components: { BravadoText },
});
</script>

<style lang="scss">
.sign-up-footer {
  color: var(--gray-50);

  &__log-in {
    text-align: center;
    margin-top: 22px;
    margin-bottom: 16px;
  }

  &__cta {
    color: var(--blue-60);
    display: inline;
    font: inherit;
    border: none;
    padding: 0;
    margin: 0;
    background: transparent;
    cursor: pointer;
  }

  &__terms {
    margin: 16px auto 0;

    a {
      text-decoration: underline;
    }
  }
}
</style>
